<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'AgreementList' }" class="nav-link">Umowy</router-link></h2><div class="page-title__buttons"><router-link :to="{ name: 'AgreementCreate' }" class="btn btn-default"><span>Dodaj umowę</span><svg-icon name="plus"/></router-link></div></page-title>

		<div class="col page-element">
			<alert-loading v-if="loading"></alert-loading>

			<div v-if="deletedItem" class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
			<div v-if="error" class="alert alert-danger">{{ error }}</div>
			
			<div v-if="!loading">	
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-hover table-clickable table-search">
					<thead>
						<tr>
							<td><b-form-input type="text" class="form-control input-search" v-model="filter.fullNumber"/><svg-icon name="search" /></td>
							<td>
								<date-range-picker v-model="selectedDatePeriod"></date-range-picker>
							</td>
							<td><b-form-input type="text" class="form-control input-search" v-model="filter.customer"/><svg-icon name="search" /></td>
							<td></td>
							<td></td>
							<td>
								<dropdown-search id="_currency" :elements="currencyTypes" v-model="filter.currency" valueField="id" nameField="name" :showEmpty="true"/>
							</td>
							<td>
								<dropdown-search id="status-dropdown" :elements="agreementStatus" v-model="filter.status" :showEmpty="true" />
							</td>
							<td></td>
							<td class="no-wrap"><my-button variant="info" :action="getItems"/> <my-button icon="back" variant="primary" :action="resetFilter"/></td>
						</tr>
						<tr>
							<th v-on:click="setOrder('fullNumber')" class="sorting" :class="getOrder('fullNumber')">Numer</th>
							<th v-on:click="setOrder('date')" class="sorting" :class="getOrder('date')">Data zawarcia</th>
							<th v-on:click="setOrder('customerData.name')" class="sorting" :class="getOrder('customerData.name')">Klient</th>
							<th v-on:click="setOrder('amount')" class="sorting" :class="getOrder('amount')">Kwota</th>
							<th v-on:click="setOrder('leftToPaid')" class="sorting" :class="getOrder('leftToPaid')">Do zapłaty</th>
							<th v-on:click="setOrder('currency.name')" class="sorting" :class="getOrder('currency.name')">Waluta</th>
							<th v-on:click="setOrder('status')" class="sorting" :class="getOrder('status')">Status</th>
							<th>Faktura</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in items">
							<td><router-link :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item['fullNumber'] }}</router-link></td>
							<td><router-link :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item['date'] | date }}</router-link></td>
							<td><router-link :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item.customerData.name }}, NIP:&nbsp;{{ item.customerData.nip }}</router-link></td>
							<td><router-link :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item.amount }}</router-link></td>
							<td><router-link :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item.leftToPaid }}</router-link></td>
							<td><router-link :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item.currency.name }}</router-link></td>
							<td><router-link :to="{name: 'AgreementShow', params: { id: item['id'] }}">
								<span class="element_status" :class="item.status">{{ item['status'] | translate }}</span>
								<div class="payment-status">
									<span v-if="item.paid" class="paid"></span>
									<span v-if="item.advancePaymentPaid" class="advancePaymentPaid"></span>
								</div>
							</router-link></td>
							<td><router-link  v-if="item.invoice" :to="{name: 'AgreementShow', params: { id: item['id'] }}">{{ item.invoice.fullNumber }}</router-link></td>
							<td>
								<router-link :to="{name: 'AgreementUpdate', params: { id: item['id'] }}" v-b-tooltip.hover.bottom title="Edytuj" class="btn btn-icon">
									<svg-icon name="edit"/>
								</router-link>
								<router-link v-if="item.invoice" :to="{name: 'InvoiceShow', params: { id: item.invoice.id }}" v-b-tooltip.hover.bottom title="Faktura" class="btn btn-icon">
									<svg-icon name="sale_small"/>
								</router-link>
								<router-link v-else-if="item.status=='closed'" :to="{name: 'InvoiceCreate', query: { agreement: item['id'] }}" v-b-tooltip.hover.bottom title="Faktura" class="btn btn-icon">
									<svg-icon name="sale_small"/>
								</router-link>
							</td>
						</tr>
					</tbody>
					</table>
				</div>
				<pagination :changePage="changePage" :currentPage="currentPage" :pagination="pagination"></pagination>
			</div>
  		</div>
	</b-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import sort from '../../utils/order';
  import http from '../../utils/http';
  import moment from 'moment';

  export default {
	data: function() {
		return {
			selectedCurrency: null,
			selectedStatus: null,
			selectedDatePeriod: null
		};
	},
    computed: mapGetters({
			deletedItem: 'agreement/del/deleted',
			error: 'agreement/list/error',
			items: 'agreement/list/items',
			loading: 'agreement/list/loading',
			currentPage: 'agreement/list/currentPage',
			pagination: 'agreement/list/pagination',
			order: 'agreement/list/order',
			filter: 'agreement/list/filter',
            currencyTypes: 'config/config/currencyTypes',
	      	agreementStatus: 'config/config/agreementStatus',
    }),
    methods: {
        resetFilter(){
          for (var key in this.filter ){
            this.filter[key] = undefined;
          }
          this.selectedDatePeriod = null;
          this.getItems();
        },
		getOrder: function(column) {
			return sort(this.order, column);
		},
	    extractId(uri){
		  return http.extractId(uri);
		},
		...mapActions({
			getItems: 'agreement/list/getItems',
			setOrder: 'agreement/list/order',
			changePage: 'agreement/list/changePage'
		})
	},
    created () {
	  this.$store.dispatch('agreement/list/getItems')
	  if(this.filter.date){
        this.selectedDatePeriod = [
          new Date( this.filter.date.after),
          new Date( this.filter.date.before)
        ]
	  }
    },
    watch: {
      selectedDatePeriod: function (date) {
        if(date){
          this.filter.date = {
            before: moment(date[1]).format('YYYY-MM-DD 23:59:59'),
            after: moment(date[0]).format('YYYY-MM-DD 00:00:00'),
          }
		}else{
          this.filter.date = undefined
		}
      }
	}
  }
</script>

<style >
	.payment-status {
		position: relative;
		display: inline-block;
	}
	.paid {
		padding: 5px;
		background-color: #669D31;
		display: inline-block;
		position: absolute;
		bottom: 4px;
	}

	.advancePaymentPaid {
		padding: 5px;
		background-color: #EC9A29;
		display: inline-block;
		position: absolute;
		top: -2px;
	}
</style>


// WEBPACK FOOTER //
// List.vue?4e11ab4a